import { useEffect } from "react";
import { useLocation } from "react-router-dom"

export const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Create a scroll controller with multiple fallbacks
    const scrollToTop = () => {
      // Method 1: Standard smooth scroll
      window.scrollTo({ top: 0 });

      // Method 2: Alternative approach for stubborn browsers
      document.documentElement.scrollTop = 0;
      
      // Method 3: Emergency fallback after delay
      setTimeout(() => {
        if (window.scrollY > 0) {
          window.scrollTo(0, 0);
        }
      }, 300);
    };

    // First attempt
    scrollToTop();

    // Second attempt after short delay
    const retryTimer = setTimeout(scrollToTop, 100);
    
    // Cleanup
    return () => {
      clearTimeout(retryTimer);
    };
  }, [location.pathname]);

  return null;
};